import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    imgCateForm: null,
    error: null,
    submitted: false,
    openLightbox: false,
    answer: '',
    anyImgCateSelected: false,
    task: null,
    updateImgCateQuestions: false,
    imgCateTypes: [],
    imgCateQuestions: [],
}

const updateAnswer = (state, action) => {
    return {
        ...state,
        imgCateForm: action.imgCateForm
    }
}

const submitError = (state, action)=>{
    return {
        ...state,
        error: action.error
    }
}

const submitSuccess = (state,action)=> {
    return {
        ...state,
        submitted: true,
        error: null,
        answer: action.answer
    }
}

const submitCompleted = (state) =>{
    return {
        ...state,
        submitted: false,
        imgCateForm: null
    }
}

const openLightbox=(state)=>{
    return {
        ...state,
        openLightbox: true
    }
}

const closeLightbox=(state)=>{
    return {
        ...state,
        openLightbox: false
    }
}

const imgCateTypeSelected=(state)=>{
    return {
        ...state,
        anyImgCateSelected: true
    }
}

const imgCateTypeDeselected=(state)=>{
    return {
        ...state,
        anyImgCateSelected: false
    }
}

const getTaskConfigSuccess=(state,action)=>{
    return {
        ...state,
        task: action.task,
        updateImgCateQuestions: true
    }
}

const getTaskConfigError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

const updateImgCateQuestion=(state,action)=>{
    return {
        ...state,
        imgCateQuestions: action.imgCateQuestions
    }
}

export default reduce(initialState,{
    [actionTypes.IMGCATE_GET_TASK_CONF_SUCCESS]: getTaskConfigSuccess,
    [actionTypes.IMGCATE_GET_TASK_CONF_ERROR]: getTaskConfigError,
    [actionTypes.IMGCATE_UPDATE_QUETIONS]: updateImgCateQuestion,
    [actionTypes.IMGCATE_TYPE_SELECTED]: imgCateTypeSelected,
    [actionTypes.IMGCATE_TYPE_DESELECTED]: imgCateTypeDeselected,
    [actionTypes.IMGCATE_UPDATE_ANSWER]: updateAnswer,
    [actionTypes.IMGCATE_OPEN_LIGHTBOX]: openLightbox,
    [actionTypes.IMGCATE_CLOSE_LIGHTBOX]: closeLightbox,
    [actionTypes.IMGCATE_SUBMIT_ERROR]: submitError,
    [actionTypes.IMGCATE_SUBMIT_SUCCESS]: submitSuccess,
    [actionTypes.IMGCATE_SUBMIT_COMPLETED]: submitCompleted,
});


// WEBPACK FOOTER //
// ./src/redux/imgCate/imgCateReducer.js